import { SubscribeQuery } from '.';

const getAll = (retailerId: string): SubscribeQuery => ({
  className: 'Bundle',
  where: {
    retailer: {
      __type: 'Pointer',
      className: 'Retailer',
      objectId: retailerId,
    },
  },
});

const getSMSBundle = (retailerId: string): SubscribeQuery => ({
  className: 'Bundle',
  where: {
    retailer: {
      __type: 'Pointer',
      className: 'Retailer',
      objectId: retailerId,
    },
    status: 'VALID',
    type: 'SMS',
  },
});

export const bundleQueries = {
  getAll,
  getSMSBundle,
};
